export default __webpack_public_path__ + "static/subtle-dots-a77c6504f04e35abb7f57574f3d4bc9c.png";